import { CalendarEventType } from '../types';

export const COLORS = {
  primary: '#00506E',
  chartPrimary: '#0DA49F',
  chartSecondary: '#89F6ED',
  chartAccent: '#FF854C',
  // UI Colors
  background: '#F5F5F5',
  white: '#FFFFFF',
  text: '#1F2937',
  textSecondary: '#6B7280',
  lightGray: '#E5E7EB',
  success: '#10B981',
  error: '#EF4444',
};

export const CALENDAR_EVENT_COLORS: Record<CalendarEventType, string> = {
  observation: '#0DA49F',
  callable: '#5B8DEF',
  maturity: '#FF854C',
};

export const CHART_COLORS: string[] = [
  '#0DA49F', // primary
  '#89F6ED', // secondary
  '#FF854C', // accent
  '#5B8DEF', // blue
  '#A78BFA', // purple
  '#34D399', // emerald
  '#F472B6', // pink
  '#F59E0B', // amber
  '#EF4444', // red
  '#8B5CF6', // violet
  '#06B6D4', // cyan
  '#84CC16', // lime
  '#F97316', // orange
  '#EC4899', // rose
  '#10B981', // green
  '#6366F1', // indigo
];
